const footLabels = [
    { id: 1, name: 'Left footed' },
    { id: 2, name: 'Right footed' },
    { id: 3, name: 'Both footed' },
];

const valueSliderData = [
    { value: 26, number: 5 },
    { value: 27, number: 20 },
    { value: 28, number: 10 },
    { value: 29, number: 25 },
    { value: 30, number: 30 },
    { value: 31, number: 35 },
    { value: 32, number: 50 },
    { value: 33, number: 70 },
    { value: 34, number: 40 },
    { value: 35, number: 60 },
    { value: 36, number: 30 },
    { value: 37, number: 25 }
];
const wagesSliderData = [
    { wages: 26, number: 5 },
    { wages: 27, number: 20 },
    { wages: 28, number: 10 },
    { wages: 29, number: 25 },
    { wages: 30, number: 30 },
    { wages: 31, number: 35 },
    { wages: 32, number: 50 },
    { wages: 33, number: 70 },
    { wages: 34, number: 40 },
    { wages: 35, number: 60 },
    { wages: 36, number: 30 },
    { wages: 37, number: 25 }
];

export { footLabels, valueSliderData, wagesSliderData };